import React from 'react';

function dividerContent() {
  return <div className="acceptable-fop__header--divider" />;
}

export default dividerContent;
